<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checkedCount="!checkedRow ? 0 : checkedRow.length"
        @query="getData"
        @reset="resetPage"
        @exportData="exportData"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable],
  data() {
    return { usePage: true, checkedRow: [] }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .fabricRequestListBySummaryApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportData(form) {
      const listCode = (this.checkedRow || []).map(
        (item) => item.fabricRequestCode
      )
      const url = '/digitalCenter/fabric/request/summaryExport'
      const fileName = `面料申请汇总数据信息_${new Date().getTime()}`
      this.$api.globalExportData(url, { ...form, listCode }, fileName)
    },
  },
}
</script>
